// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"f3784f10","380":"5b3fe46f","419":"96c8fe0a","563":"e50b07ff","990":"61d9dc0d"}[chunkId] + ".chunk.js";
};